import i18n from '@/lang';
/* unplugin-vue-components disabled */
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "item",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.info.name) + " "), _vm.info.state === 0 ? _c('span', [_vm._v(i18n.tc("469"))]) : _vm._e()]), _c('div', {
    staticClass: "extra"
  }, [_vm._v(i18n.tc("470") + _vm._s(_vm.info.update_name) + (" " + i18n.tc("461")) + _vm._s(_vm.info.update_time))]), _c('div', {
    staticClass: "down"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(i18n.tc("471"))]), _c('div', {
    staticClass: "downlist"
  }, _vm._l(_vm.info.fileUrl ? _vm.info.fileUrl.split(',') : [], function (item, index) {
    return _c('p', {
      key: index,
      staticStyle: {
        "margin-bottom": "0.3rem"
      }
    }, [_vm._v(" " + _vm._s(_vm.showName(item)) + " "), _c('a', {
      staticClass: "down_btn",
      staticStyle: {
        "margin-right": "4px"
      },
      attrs: {
        "download": _vm.showName(item),
        "href": item,
        "target": "_blank"
      }
    }, [_vm._v(i18n.tc("103"))]), _c('a', {
      staticClass: "down_btn",
      attrs: {
        "href": _vm.previewUrl(item),
        "target": "_blank"
      }
    }, [_vm._v(i18n.tc("472"))])]);
  }), 0)]), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.decodeHtml)
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };